<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Historial del registro</span>
  <button mat-icon-button (click)="cerrar()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div *ngIf="cargando" style="text-align:center;padding:16px">
    <mat-icon>hourglass_empty</mat-icon>
  </div>

  <div *ngIf="!cargando && historial.length === 0" style="text-align:center;color:#9e9e9e;padding:16px">
    Este registro no tiene cambios registrados.
  </div>

  <mat-list *ngIf="!cargando && historial.length > 0">
    <mat-list-item *ngFor="let cambio of historial" style="height:auto;padding:8px 0">
      <div style="display:flex;flex-direction:column;gap:4px;width:100%">
        <div style="display:flex;justify-content:space-between">
          <strong>{{ nombreTipoCambio(cambio.tipoCambio) }}</strong>
          <span>{{ cambio.fechaCambio | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <span>{{ cambio.motivo }}</span>
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cerrar()">
    Cerrar
  </button>
</mat-dialog-actions>
